// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.applications.RentalManagerUserApplicationsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserApplicationsWebApiHandler_enableApplications,
  RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing,
  RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  GetApplicationPermissionsForListingResponseWebDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface GetApplicationPermissionsForListingParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserApplicationsWebApiHandler_enableApplications_Options = UseMutationOptions<
  void,
  unknown,
  void
>;

/**
 * Enable applications for the user
 */
export const useRentalManagerUserApplicationsWebApiHandler_enableApplications = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserApplicationsWebApiHandler_enableApplications_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => RentalManagerUserApplicationsWebApiHandler_enableApplications(httpClient),
  });
};

export type RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_Options = UseQueryOptions<
  GetApplicationPermissionsForListingResponseWebDto,
  unknown,
  GetApplicationPermissionsForListingResponseWebDto,
  readonly [string, GetApplicationPermissionsForListingParams]
>;

const RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_GetKey = (
  getParams: GetApplicationPermissionsForListingParams,
) => [RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_Path, getParams] as const;

export const RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_queryOptions = (
  getParams: GetApplicationPermissionsForListingParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_GetKey(getParams),
    queryFn: () =>
      RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Checks if the logged in user can view and manage rental applications for a listing
 */
export const useRentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing = (
  getParams: GetApplicationPermissionsForListingParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing.getKey =
  RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_GetKey;
